var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 80,
    viewBox: "0 0 39 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1907_42",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 80,
    rx: 4,
    fill: "url(#paint0_linear_1907_42)",
    fillOpacity: 0.8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1907_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4 64C3.915 64 2.64375 63.4778 1.58625 62.4333C0.52875 61.3889 0 60.1333 0 58.6667V21.3333C0 19.8667 0.52875 18.6111 1.58625 17.5667C2.64375 16.5222 3.915 16 5.4 16H48.6C50.085 16 51.3563 16.5222 52.4138 17.5667C53.4713 18.6111 54 19.8667 54 21.3333V58.6667C54 60.1333 53.4713 61.3889 52.4138 62.4333C51.3563 63.4778 50.085 64 48.6 64H5.4ZM5.4 58.6667H48.6V21.3333H5.4V58.6667ZM13.5 53.3333H40.5C41.265 53.3333 41.9062 53.0778 42.4238 52.5667C42.9412 52.0556 43.2 51.4222 43.2 50.6667C43.2 49.9111 42.9412 49.2778 42.4238 48.7667C41.9062 48.2556 41.265 48 40.5 48H13.5C12.735 48 12.0938 48.2556 11.5763 48.7667C11.0588 49.2778 10.8 49.9111 10.8 50.6667C10.8 51.4222 11.0588 52.0556 11.5763 52.5667C12.0938 53.0778 12.735 53.3333 13.5 53.3333ZM13.5 42.6667H18.9C19.665 42.6667 20.3063 42.4111 20.8238 41.9C21.3413 41.3889 21.6 40.7556 21.6 40V29.3333C21.6 28.5778 21.3413 27.9444 20.8238 27.4333C20.3063 26.9222 19.665 26.6667 18.9 26.6667H13.5C12.735 26.6667 12.0938 26.9222 11.5763 27.4333C11.0588 27.9444 10.8 28.5778 10.8 29.3333V40C10.8 40.7556 11.0588 41.3889 11.5763 41.9C12.0938 42.4111 12.735 42.6667 13.5 42.6667ZM29.7 42.6667H40.5C41.265 42.6667 41.9062 42.4111 42.4238 41.9C42.9412 41.3889 43.2 40.7556 43.2 40C43.2 39.2444 42.9412 38.6111 42.4238 38.1C41.9062 37.5889 41.265 37.3333 40.5 37.3333H29.7C28.935 37.3333 28.2938 37.5889 27.7763 38.1C27.2588 38.6111 27 39.2444 27 40C27 40.7556 27.2588 41.3889 27.7763 41.9C28.2938 42.4111 28.935 42.6667 29.7 42.6667ZM29.7 32H40.5C41.265 32 41.9062 31.7444 42.4238 31.2333C42.9412 30.7222 43.2 30.0889 43.2 29.3333C43.2 28.5778 42.9412 27.9444 42.4238 27.4333C41.9062 26.9222 41.265 26.6667 40.5 26.6667H29.7C28.935 26.6667 28.2938 26.9222 27.7763 27.4333C27.2588 27.9444 27 28.5778 27 29.3333C27 30.0889 27.2588 30.7222 27.7763 31.2333C28.2938 31.7444 28.935 32 29.7 32Z",
    fill: "#423ED8",
    fillOpacity: 0.14
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1907_42",
    x1: 0,
    y1: 40,
    x2: 32.2584,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B58F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.fe587b20a958db326cfa18db4af028cd.svg";
export { ForwardRef as ReactComponent };